package fr.labodoc.healthProfessional.webApp.pages.profile.profileInformation

import arrow.core.raise.either
import fr.labodoc.healthProfessional.webApp.App
import fr.labodoc.healthProfessional.webApp.data.error.RemoteDataSourceError
import fr.labodoc.healthProfessional.webApp.data.error.RepositoryError
import fr.labodoc.healthProfessional.webApp.data.repository.UsersRepository
import kotlinx.coroutines.flow.*
import kotlinx.coroutines.launch

class ProfileInformationViewModelImpl(
  private val userRepository: UsersRepository
) : ProfileInformationViewModel() {
  private val _uiState: MutableStateFlow<UiState> = MutableStateFlow(UiState.Loading)
  override val uiState: StateFlow<UiState> = _uiState.asStateFlow()

  private val _events: MutableSharedFlow<Event> = MutableSharedFlow()
  override val events: SharedFlow<Event> = _events.asSharedFlow()

  init {
    App.Companion.scope.launch {
      val newUiState = either {
        val self = userRepository.getSelf()
          .mapLeft { UiState.Error }
          .bind()

        UiState.Loaded(
          firstName = self.firstName,
          lastName = self.lastName,
          rppsNumber = self.rppsNumber,
          medicalProfession = self.medicalProfession?.name,
          professionalCategory = self.professionalCategory.name,
          medicalSpeciality = self.medicalSpeciality?.name,
          department = "${self.department.name} (${self.department.code})",
          email = self.emailAddress
        )
      }
        .fold({ it }, { it })

      _uiState.update {
        newUiState
      }
    }
  }

  override fun changePassword(oldPassword: String, newPassword: String) {
    App.Companion.scope.launch {
      userRepository.changePassword(oldPassword, newPassword)
        .onLeft { error ->
          val errorCode = if (error is RepositoryError.DataSource)
            (error.cause as? RemoteDataSourceError.SomethingWentWrong)?.cause?.error?.code
          else
            null

          errorCode?.let { _events.emit(Event.ChangePasswordFailed(it)) }
        }
        .onRight {
          _events.emit(Event.ChangePasswordSucceed)
        }
    }
  }

  override fun deleteAccount() {
    App.Companion.scope.launch {
      userRepository.deleteAccount()
        .onLeft { error ->
          val errorCode = if (error is RepositoryError.DataSource)
            (error.cause as? RemoteDataSourceError.SomethingWentWrong)?.cause?.error?.code
          else
            null

          errorCode?.let { _events.emit(Event.DeleteAccountFailed(it)) }
        }
        .onRight {
          _events.emit(Event.DeleteAccountSucceed)
        }
    }
  }
}
